export default __webpack_public_path__ + "static/media/logo-yalo-horizontal.1ae4f7fc.png";